import React from 'react'
import AttributeMappingRow from './AttributeMappingRow'
import { EmptyState, ErrorState, LoadingState } from '../../Shared/Components/MappingStates'
import Shared from '../../Shared/mappingUi.module.css'
import Style from '../productAttribute.module.css'

const AttributeMappingList = ({
    rows,
    direction,
    leftTitle,
    rightTitle,
    erpFields,
    ecommerceFields,
    isLoading,
    loadError,
    isDisabled,
    onChange,
    onRemove
}) => {
    if (isLoading) {
        return <LoadingState message="Loading product attribute details..." />
    }
    if (loadError) {
        return <ErrorState message={loadError} />
    }
    if (rows.length === 0) {
        return (
            <EmptyState
                icon="uil-list-ul"
                message="No product attribute mappings yet"
                hint={`Use "Add New Mappings" to pair ${leftTitle} fields with ${rightTitle} fields.`}
            />
        )
    }

    return (
        <>
            <div className={`${Shared.grid} ${Style.grid} ${Shared.listHeader}`}>
                <span>{leftTitle} Field</span>
                <span />
                <span>{rightTitle} Field</span>
                <span className={Shared.listHeaderAction}>Action</span>
            </div>
            <ul className={Shared.list}>
                {rows.map((row) => (
                    <AttributeMappingRow
                        key={row.rowId}
                        row={row}
                        direction={direction}
                        leftTitle={leftTitle}
                        rightTitle={rightTitle}
                        erpFields={erpFields}
                        ecommerceFields={ecommerceFields}
                        isDisabled={isDisabled}
                        onChange={onChange}
                        onRemove={onRemove}
                    />
                ))}
            </ul>
        </>
    )
}

export default AttributeMappingList
